import React from 'react';
import ReactDOM from 'react-dom';
import YouTubeVideo from 'common/YouTubeVideo';

class VideoModal {
  constructor() {
    this.el = document.querySelector('.video-modal');
    this.iframeWrapperEl = document.querySelector(
      '[data-js="video-modal-iframe-wrapper"]'
    );
    this.closerEl = document.querySelector('.video-modal__closer');

    this.closerEl && this.closerEl.addEventListener('click', this.close);
  }

  close = () => {
    document.body.classList.remove('no-scroll');
    this.el.classList.add('hide');
    ReactDOM.unmountComponentAtNode(this.iframeWrapperEl);
    document.onkeydown = this._onkeydown;
  };

  showVideo(url) {
    document.body.classList.add('no-scroll');
    this.el.classList.remove('hide');
    ReactDOM.render(<YouTubeVideo videoURL={url} />, this.iframeWrapperEl);
    this._onkeydown = document.onkeydown;
    document.onkeydown = this.handleKeyDown;
  }

  handleKeyDown = e => {
    e = e || window.event;

    if (e.keyCode === 27) {
      this.close();
    }
  };
}

class VideoTestimonial {
  constructor(video, videoModal) {
    this.video = video;
    this.videoModal = videoModal;
    this.showMobile = video.dataset.show_mobile === 'true';

    this.initialize();

    window.addEventListener('resize', this.initialize);
  }

  initialize = () => {
    if (!this.showMobile && document.documentElement.clientWidth < 768) {
      return;
    }

    const videoImage = this.video.querySelector('.js-home-video-image');
    if (videoImage) {
      videoImage.setAttribute('src', this.video.dataset.image_src);
    }

    const videoOverlay = this.video.querySelector(
      '.js-home-video-overlay-container'
    );
    if (videoOverlay) {
      videoOverlay.addEventListener('click', this.handleVideoClick);
    }

    this.video &&
      this.video.addEventListener('mouseover', this.handleVideoMouseOver);
    this.video &&
      this.video.addEventListener('mouseout', this.handleVideoMouseOut);

    window.removeEventListener('resize', this.initialize);
  };

  handleVideoClick = () => {
    if (!this.video.dataset.youtube_url) {
      return;
    }

    this.videoModal.showVideo(this.video.dataset.youtube_url);
  };

  handleVideoMouseOver = () => {
    this.toggleOverlayElements(true);
  };

  handleVideoMouseOut = () => {
    this.toggleOverlayElements(false);
  };

  toggleOverlayElements = (show = true) => {
    const { overlay, overlayText } = this.getVideoOverlayElements();
    const className = 'hide-tablet';

    if (overlay && overlayText) {
      if (show) {
        overlay.classList.remove(className);
        overlayText.classList.remove(className);
      } else {
        overlay.classList.add(className);
        overlayText.classList.add(className);
      }
    }
  };

  getVideoOverlayElements = () => {
    return {
      overlay: this.video.querySelector('.js-home-video-overlay'),
      overlayText: this.video.querySelector('.js-home-video-overlay-text'),
    };
  };
}

class VideoTestimonials {
  constructor() {
    this.videoModal = new VideoModal();
    this.initializeTestimonialVideos();
  }

  initializeTestimonialVideos() {
    const videos = document.querySelectorAll('.js-home-video');
    for (let i = 0; i < videos.length; i++) {
      new VideoTestimonial(videos[i], this.videoModal);
    }
  }
}

export default VideoTestimonials;
